<div class="claims">
	<router-outlet>
	</router-outlet>
</div>